import axios from 'axios';
import store from '@/store/store'
import router from "@/router";

const baseURL = process.env.VUE_APP_API_BASE_URL ;
if (!baseURL) {
  throw new Error('Missing VUE_APP_API_BASE_URL');
}

const instance = axios.create({
  baseURL,
  timeout: 15000,
});

function getStoredAuth() {
  if (typeof window === "undefined") {
    return null;
  }

  const raw = window.localStorage.getItem("objs") || window.sessionStorage.getItem("objs");
  return raw ? JSON.parse(raw) : null;
}

function clearAuthStorage() {
  if (typeof window === "undefined") {
    return;
  }

  window.sessionStorage.removeItem("objs");
  window.localStorage.removeItem("objs");
}


// เพิ่ม request interceptor
instance.interceptors.request.use(
    (config) => {
        const storedAuth = getStoredAuth() || {};
        const token = store.state.XAccessToken || storedAuth.xAccessToken;
        if (token) {
            config.headers['X-Access-Token'] = token;
        }
        config.headers["Content-Type"] = config.headers["Content-Type"] || "application/json";
        config.headers["Accept"] = "application/json";
        config.headers.lang = `${store.getters['setting/lang'] || "th"}`;
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);


// เพิ่ม Interceptor สำหรับ Response
instance.interceptors.response.use(
    (response) => {
      // คืนค่าปกติหาก response สำเร็จ
      return response;
    },
    (error) => {
      // ตรวจสอบสถานะ 401
      if (error.response && error.response.status === 401) {
        clearAuthStorage();
        router.push('/login');
      }
      return Promise.reject(error);
    }
);

export default {
  // CONFIG

  onLogin(body) {
    return instance.post("/authen/APILogin",body)
  },

  onGetProject(body) {
    return instance.get("/api/v1/setting/project")
  },

  onCreateProject(body) {
    return instance.post("/api/v1/setting/project",body)
  },

  onUpdatetProject(body) {
    return instance.put("/api/v1/setting/project",body)
  },

  onGetAccounts(body) {
    return instance.post("/api/v1/setting/accounts",body)
  },

  onGetStatus() {
    return instance.get("/api/v1/setting/status")
  },



  //
  singin(body) {
    return instance.post("/api/v1/singin",body)
  },

  importAccounts(body) {
    return instance.post("/api/v1/setting/accounts/import", body, {
      timeout: 5200000,
    })
  },




  // config
  login(method, data, configs) {
    switch (method){
      case 'get':
        return instance.get("/api/v1/setting/authen");
      case 'post':
        delete data._id;
        return instance.post("/api/v1/setting/authen", data);
      case 'put':
        return instance.put("/api/v1/setting/authen", data);
      case 'delete':
        return instance.delete("/api/v1/setting/authen");
      default:
        break;
    }
  },

  campus(method, data, configs) {
    switch (method){
      case 'exp':
        return instance.post("/api/v1/explore/campus",data);
      case 'get':
        return instance.get("/api/v1/setting/campus");
      case 'post':
        delete data._id;
        return instance.post("/api/v1/setting/campus", data);
      case 'put':
        return instance.put("/api/v1/setting/campus", data);
      case 'delete':
        return instance.delete("/api/v1/setting/campus");
      default:
        break;
    }
  },

  facultys(method, data, configs) {
    switch (method){
      case 'exp':
        return instance.post("/api/v1/explore/facultys",data);
      case 'get':
        return instance.get("/api/v1/setting/faculty");
      case 'post':
        delete data._id;
        return instance.post("/api/v1/setting/faculty", data);
      case 'put':
        return instance.put("/api/v1/setting/faculty", data);
      case 'delete':
        return instance.delete("/api/v1/setting/faculty");
      default:
        break;
    }
  },

  departments(method, data, configs) {
    switch (method){
      case 'exp':
        return instance.post("/api/v1/explore/departments",data);
      case 'get':
        return instance.get("/api/v1/setting/department");
      case 'post':
        delete data._id;
        return instance.post("/api/v1/setting/department", data);
      case 'put':
        return instance.put("/api/v1/setting/department", data);
      case 'delete':
        return instance.delete("/api/v1/setting/department");
      default:
        break;
    }
  },

  course(method, data, configs) {
    switch (method){
      case 'exp':
        return instance.post("/api/v1/explore/course",data);
      case 'get':
        return instance.get("/api/v1/setting/course");
      case 'post':
        delete data._id;
        return instance.post("/api/v1/setting/course", data);
      case 'put':
        return instance.put("/api/v1/setting/course", data);
      case 'delete':
        return instance.delete("/api/v1/setting/course");
      default:
        break;
    }
  },

  operations(method, data, configs) {
    switch (method){
      case 'exp':
        return instance.post("/api/v1/explore/operation",data);
      case 'get':
        return instance.get("/api/v1/setting/operation");
      case 'post':
        delete data._id;
        return instance.post("/api/v1/setting/operation", data);
      case 'put':
        return instance.put("/api/v1/setting/operation", data);
      case 'delete':
        return instance.delete("/api/v1/setting/operation");
      default:
        break;
    }
  },

  // config
  skill(method, data, configs) {
    switch (method){
      case 'exp':
        return instance.post("/api/v1/explore/skills",data);
      case 'get':
        return instance.get("/api/v1/setting/skills");
      case 'post':
        delete data._id;
        return instance.post("/api/v1/setting/skills", data);
      case 'put':
        return instance.put("/api/v1/setting/skills", data);
      case 'delete':
        return instance.delete("/api/v1/setting/skills");
      default:
        break;
    }
  },

  // config
  assessmentBook(method, data, configs) {
    switch (method){
      case 'exp':
        return instance.post("/api/v1/setting/assessment/books",data);
      case 'post':
        delete data._id;
        return instance.post("/api/v1/setting/assessment/book", data);
      case 'put':
        return instance.put("/api/v1/setting/assessment/book", data);
      case 'delete':
        return instance.delete("/api/v1/setting/assessment/book");
      default:
        break;
    }
  },



  // setting/assessment/books


  EProtMapping(method, data, configs) {
    switch (method){
      case 'exp':
        return instance.post("/api/v1/explore/mapping",data);
      case 'get':
        return instance.get("/api/v1/mapping");
      case 'post':
        delete data._id;
        return instance.post("/api/v1/mapping", data);
      case 'put':
        return instance.put("/api/v1/mapping", data);
      case 'delete':
        return instance.delete("/api/v1/mapping");
      default:
        break;
    }
  },


  members(method, data, configs) {
    switch (method){
      case 'exp':
        return instance.post("/api/v1/explore/personal",data);
      case 'get':
        return instance.get("/api/v1/personal");
      case 'post':
        delete data._id;
        return instance.post("/api/v1/personal", data);
      case 'put':
        return instance.put("/api/v1/personal", data);
      case 'delete':
        return instance.delete("/api/v1/personal");
      default:
        break;
    }
  },

  organization(method, data, configs) {
    switch (method){
      case 'exp':
        return instance.post("/api/v1/explore/organization",data);
      case 'get':
        return instance.get("/api/v1/setting/organization");
      case 'post':
        delete data._id;
        return instance.post("/api/v1/setting/organization", data);
      case 'put':
        return instance.put("/api/v1/setting/organization", data);
      case 'delete':
        return instance.delete("/api/v1/setting/organization");
      default:
        break;
    }
  },

  agency(method, data, configs) {
    switch (method){
      case 'exp':
        return instance.post("/api/v1/setting/explore/agency",data);
      case 'get':
        return instance.get("/api/v1/setting/agency");
      case 'post':
        delete data._id;
        return instance.post("/api/v1/setting/agency", data);
      case 'put':
        return instance.put("/api/v1/setting/agency", data);
      case 'delete':
        return instance.delete("/api/v1/setting/agency");
      default:
        break;
    }
  },

  agencyChart(method, data, configs) {
    switch (method){
      case 'exp':
        return instance.post("/api/v1/setting/explore/agency/chart",data);
      case 'get':
        return instance.get("/api/v1/setting/agency/chart");
      case 'post':
        delete data._id;
        return instance.post("/api/v1/setting/agency/chart", data);
      case 'put':
        return instance.put("/api/v1/setting/agency/chart", data);
      case 'delete':
        return instance.delete("/api/v1/setting/agency/chart");
      default:
        break;
    }
  },

  personal(method, data, configs) {
    switch (method){
      case 'exp':
        return instance.post("/api/v1/personal",data);
      case 'get':
        return instance.get("/api/v1/personal");
      case 'post':
        delete data._id;
        return instance.post("/api/v1/personal", data);
      case 'put':
        return instance.put("/api/v1/personal", data);
      case 'delete':
        return instance.delete("/api/v1/personal", data);
      default:
        break;
    }
  },

  admin(method, data, configs) {
    switch (method){
      case 'exp':
        return instance.post("/api/v1/explore/admin",data);
      case 'get':
        return instance.get("/api/v1/setting/admin");
      case 'post':
        delete data._id;
        return instance.post("/api/v1/setting/admin", data);
      case 'put':
        return instance.put("/api/v1/setting/admin", data);
      case 'delete':
        return instance.delete("/api/v1/setting/admin", data);
      default:
        break;
    }
  },

  estimatesAssessment(method, data, configs) {
    switch (method){
      case 'exp':
        return instance.post("/api/v1/explore/assessment",data);
      case 'report-status':
        return instance.post("/api/v1/explore/assessment/report/status",data);
      case 'report-gap':
        return instance.post("/api/v1/explore/assessment/report/gaps",data);
      case 'report-group':
        return instance.post("/api/v1/explore/assessment/report/group",data);
      case 'post':
        return instance.post("/api/v1/assessment", data);
      case 'put':
      case 'update':
        return instance.put("/api/v1/assessment", data);
      case 'delete':
        return instance.delete("/api/v1/assessment", data);
      default:
        break;
    }
  },

  idp(method, data, configs) {
    switch (method){
      case 'init':
        return instance.post("/api/v1/idp/init",data);
      case 'explore':
        return instance.post("/api/v1/explore/idp",data);
      case 'post':
        return instance.post("/api/v1/idp",data);
      case 'put':
        return instance.put("/api/v1/idp",data);
      case 'change-assessor':
        return instance.post("/api/v1/idp/change/assessor",data);
      default:
        break;
    }
  },

  // idp report for HR modules
  idpReport(method, data, configs) {
    switch (method){
      case 'status':
        return instance.post("/api/v1/explore/idp/report/status",data);
      default:
        break;
    }
  },

  // idp report for competency report modules
  idpReportCompetency(method, data, configs) {
    switch (method) {
      case 'explore':
        return instance.post("/api/v1/explore/report/idp", data);
      case 'status':
        return instance.post("/api/v1/explore/report/idp/status", data);
      case 'plans':
        return instance.post("/api/v1/explore/report/idp/plan", data);
      default:
        break;
    }
  },

  idp_method(method, data, configs) {
    switch (method){
      case 'get':
        return instance.get("/api/v1/setting/idp/method",data);
      default:
        break;
    }
  },

  idp_course(method, data, configs) {
    switch (method){
      case 'get':
        return instance.get("/api/v1/setting/idp/training",data);
      default:
        break;
    }
  },

  Report_Method(method, data, configs) {
    switch (method) {
      case 'report_method':
        return instance.post("/api/v1/explore/report/method", data);
      default:
        break;
    }
  },

  Report_Assessment(method, data, configs) {
    switch (method) {
      case 'report_assessment':
        return instance.post("/api/v1/explore/report/assessment", data);
      default:
        break;
    }
  },

  assessment(method, data, configs) {
    switch (method){
      case 'exp':
        return instance.post("/api/v1/setting/explore/assessment",data);
      case 'get':
        return instance.get("/api/v1/setting/assessment");
      case 'post':
        delete data._id;
        return instance.post("/api/v1/setting/assessment", data);
      case 'put':
        return instance.put("/api/v1/setting/assessment", data);
      case 'delete':
        return instance.post("/api/v1/assessment/revoke",data);
      default:
        break;
    }
  },




}
